import React, { useRef, useCallback, useEffect } from 'react';

import { Tooltip } from 'antd';

import { useDrag, useDrop } from 'react-dnd';

import PropTypes from 'prop-types';
import {
  fullDataDataPointsProps,
  // fullDataProps,
} from 'app/constants/PropType/propTypesFullData';

import { Point } from 'app/libs/map/drive/Point';

import { DeleteOutlined } from '@ant-design/icons';
import pointStart from 'static/images/icons/start_point.svg';
import pointEnd from 'static/images/icons/end_point.svg';
import pointHomeStart from 'static/img/svg/Home_-_start_point.svg';
import pointHome from 'static/img/svg/homeMapIcon.svg';
import add from 'static/images/icons/Add_1.svg';
import { Type } from 'app/constants/TourPoints';
import { isIE } from 'react-device-detect';
import withTranslations from 'app/components/HOGs/withTranslations';
import DragPoint1 from '../../../../../static/images/icons/drag_grey.svg';
import viaPoint from '../../../../../static/images/icons/via_point.svg';
import swap from '../../../../../static/images/icons/swap.svg';

import { TourCorrectIcon } from '../icons.svg';
import AutoCompleteAddress from '../../Autocomplete/AutocompleteAddress';
import { getPointIcon } from '../extraFuncs';

import { DnDPointIcon } from '../../MainMenu/svg';

export const ItemTypes = {
  INPUT: 'input',
};
const arePropsDifferene = (prevProps, nextProps) => {
  return (
    nextProps.activePointId !== nextProps.point.id &&
    prevProps.activePointId !== prevProps.point.id &&
    nextProps.dataPointId !== nextProps.point.id &&
    prevProps.dataPointId !== prevProps.point.id &&
    prevProps.edit === nextProps.edit &&
    prevProps.point.type === nextProps.point.type &&
    // prevProps.point.address === nextProps.point.address &&
    typeof prevProps.point.isWrongCoord === 'function' &&
    typeof nextProps.point.isWrongCoord === 'function' &&
    prevProps.point.isWrongCoord() === nextProps.point.isWrongCoord() &&
    prevProps.point.number === nextProps.point.number
  );
};

const InputPoint = (props) => {
  const {
    tr,
    point,
    index,
    activePointId,
    dataPointId,
    addPoint,
    convertToVia,
    convertToDrag,
    edit,
    itemClickHandler,
    itemOverHandler,
    setSelectedPoint,
    getClassForSelect,
    moveCard,
    dragEnd,
    deletePoint,
    setSelectedAutocomplete,
    pointListLength,

    homeAddress,
    workAddress,
    currentLocation,
    setHomeAddressUser,
    setWorkAddressUser,
    changeCursorWrapperClassName,
    userHomeAs,
    convertStartToHome,
    convertEndToHome,
    checkWrongPointPosition,
  } = props;
  const { id } = point;
  const ref = useRef(null);
  const refLayer = useRef(null);
  const refPoint = useRef(null);

  // eslint-disable-next-line
  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.INPUT,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!refLayer.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = refLayer.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag, previewLayer] = useDrag({
    type: ItemTypes.INPUT,
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end(item) {
      dragEnd(item);
    },
  });

  drag(ref);
  drop(refLayer);
  previewLayer(refLayer);

  const opacity = isDragging ? 0 : 1;

  const isSelectedPoint = (point) =>
    dataPointId === point.id || activePointId === point.id;

  useEffect(() => {
    if (activePointId === point.id) {
      refPoint.current.classList.value = !edit
        ? 'pointLayout view viewSelectPoint'
        : 'pointLayout selectPoint';
    } else {
      refPoint.current.classList.value = !edit
        ? 'pointLayout view'
        : 'pointLayout';
    }
  }, [activePointId]);

  const getBottomNumber = () => {
    if (
      (point.type === Point.Type.VIA || point.type === Point.Type.DRAG) &&
      edit
    ) {
      return 2;
    }

    return 0;
  };

  const prefixReander = () => {
    const prefix = !isDragging ? (
      <>
        {edit ? (
          <div
            className="prefix_point_list"
            style={{ marginRight: '1px' }}
            ref={(link) => {
              ref.current = link;
            }}
          >
            <DnDPointIcon />
          </div>
        ) : null}
        <div
          className={point.type === Point.Type.VIA ? 'via' : ''}
          style={{
            position: 'relative',
            left: '-1px',
            bottom: getBottomNumber(),
          }}
        >
          {getPointIcon(point, isSelectedPoint(point))}
          {point.number &&
          !point.place_type &&
          point.type === Point.Type.VIA ? (
            <div className="via-counter" style={{ top: '-2px', right: '-3px' }}>
              {point.number}
            </div>
          ) : null}
          {edit &&
          point.number &&
          !point.place_type &&
          point.type === Point.Type.DRAG ? (
            <div
              className="via-counter"
              style={{
                top: '-1px',
                right: '-4px',
                color: isSelectedPoint(point) ? '#fff' : '#333',
              }}
            >
              {point.number}
            </div>
          ) : null}
        </div>
      </>
    ) : null;
    return prefix;
  };

  const changeTypePoint = () => {
    switch (point.type) {
      case Point.Type.VIA:
        return (
          <div
            className="swapTypePoint"
            onClick={(e) => convertToDrag(point.getId(), e)}
            aria-hidden
          >
            <img src={DragPoint1} alt="drag" />
            <img src={swap} className="swap" alt="swap" />
            <img
              src={viaPoint}
              className="via"
              style={{ opacity: 0.5 }}
              alt="via"
            />
          </div>
        );
      case Point.Type.DRAG:
        return (
          <div
            className="swapTypePoint"
            onClick={(e) => convertToVia(point.getId(), e)}
            aria-hidden
          >
            <img src={DragPoint1} style={{ opacity: 0.5 }} alt="drag" />
            <img src={swap} className="swap" alt="swap" />
            <img src={viaPoint} className="via" alt="via" />
          </div>
        );
      case Point.Type.START:
        return point.iconType === 'home_start' ? (
          <div
            className="swapTypePoint"
            onClick={(e) => convertStartToHome(e, point.getId())}
            aria-hidden
          >
            <img src={pointStart} className="start" alt="start" />
            <img src={swap} className="swap" alt="swap" />
            <img
              src={pointHomeStart}
              className="start"
              style={{ opacity: 0.5 }}
              alt="home"
            />
          </div>
        ) : (
          <div
            className="swapTypePoint"
            onClick={(e) => {
              userHomeAs(Type.START, () => false, point.getId(), e);
            }}
            aria-hidden
          >
            <img
              src={pointStart}
              className="start"
              style={{ opacity: 0.5 }}
              alt="start"
            />
            <img src={swap} className="swap" alt="swap" />
            <img src={pointHomeStart} className="start" alt="home" />
          </div>
        );
      case Point.Type.END:
        return point.iconType === 'home_end' ? (
          <div
            className="swapTypePoint"
            onClick={(e) => convertEndToHome(e, point.getId())}
            aria-hidden
          >
            <img src={pointEnd} className="start" alt="start" />
            <img src={swap} className="swap" alt="swap" />
            <img
              src={pointHome}
              className="start"
              style={{ opacity: 0.5 }}
              alt="home"
            />
          </div>
        ) : (
          <div
            className="swapTypePoint"
            onClick={(e) => userHomeAs(Type.END, () => false, point.getId(), e)}
            aria-hidden
          >
            <img
              src={pointEnd}
              className="start"
              style={{ opacity: 0.5 }}
              alt="start"
            />
            <img src={swap} className="swap" alt="swap" />
            <img src={pointHome} className="start" alt="home" />
          </div>
        );
      default:
        return null;
    }
  };

  const suffixRender = (point) => {
    return edit && (!point.isEmpty || pointListLength > 2) ? (
      <span className="ant-input-suffix">
        <div
          className="suffix_point_list"
          onMouseOver={() => {
            refPoint.current.style.border = '1px solid #aa2493';
            // refPoint.current.classList.value = 'pointLayout inputOver';
          }}
          onMouseOut={() => {
            refPoint.current.style.border = '1px solid transparent';
            // refPoint.current.classList.value = 'pointLayout';
          }}
          onFocus={() => false}
          onBlur={() => false}
        >
          {changeTypePoint()}
          <Tooltip title={tr.Delete}>
            <DeleteOutlined
              style={{
                fontSize: 15,
                position: 'relative',
                left: 22,
                top: -1,
                color: '#aa2493',
              }}
              onClick={() => deletePoint(point)}
            />
          </Tooltip>
        </div>
      </span>
    ) : null;
  };

  const addViaPointLayout = () => {
    if (
      edit &&
      (point.type === Point.Type.START ||
        point.type === Point.Type.VIA ||
        point.type === Point.Type.DRAG)
    ) {
      return (
        <div
          className="addViaPoint"
          style={{ opacity }}
          onClick={() => addPoint(index)}
          aria-hidden
        >
          <Tooltip title={tr['Add via point']}>
            <img
              src={add}
              alt="Add via point"
              style={{ width: 13, height: 13, cursor: 'pointer' }}
            />
          </Tooltip>
        </div>
      );
    }
    return null;
  };
  const { correctLat, correctLng, keppCurrentCoord, lat, lng } = point;
  const mamoizedCallback = useCallback(() => {
    checkWrongPointPosition(lat, lng);
  }, [correctLat, correctLng]);
  return (
    <div
      ref={(link) => {
        setSelectedPoint(link, point);
        refPoint.current = link;
      }}
      className={edit ? 'pointLayout' : 'pointLayout view'}
      onMouseEnter={() => {
        itemOverHandler(point);
        refPoint.current.style.border = '1px solid #aa2493';
      }}
      onMouseLeave={() => {
        refPoint.current.style.border = '1px solid transparent';
        itemOverHandler(point, true);
      }}
    >
      <div
        key={point.id}
        ref={(link) => {
          refLayer.current = link;
        }}
        className={point.type === Point.Type.DRAG ? 'drag_ponint_list' : ''}
        style={{ opacity, position: 'relative', width: '100%' }}
      >
        <AutoCompleteAddress
          itemClickHandler={itemClickHandler}
          key={point.id}
          edit={edit}
          point={point}
          prefix={prefixReander}
          suffix={isDragging ? null : suffixRender}
          getClass={dataPointId === point.id ? getClassForSelect : ''}
          setSelectedAutocomplete={setSelectedAutocomplete}
          isDragging={isDragging}
          homeAddress={homeAddress}
          workAddress={workAddress}
          currentLocation={currentLocation}
          setHomeAddressUser={setHomeAddressUser}
          setWorkAddressUser={setWorkAddressUser}
          changeCursorWrapperClassName={changeCursorWrapperClassName}
        />
        {!isIE && edit && correctLat && correctLng && !keppCurrentCoord ? (
          <Tooltip title={tr['Click red symbol to check']}>
            <span
              className="wrong-ponint-list-marker"
              onClick={mamoizedCallback}
              aria-hidden
            >
              <span>
                <TourCorrectIcon />
              </span>
            </span>
          </Tooltip>
        ) : null}
      </div>
      {addViaPointLayout()}
    </div>
  );
};

InputPoint.displayName = 'InputPoint';
InputPoint.propTypes = {
  point: PropTypes.shape(fullDataDataPointsProps),
  index: PropTypes.number,
  edit: PropTypes.bool,
  // fullData: PropTypes.shape(fullDataProps),
  // InputSuffix: PropTypes.func,
  // dataPoints: PropTypes.arrayOf(PropTypes.shape(fullDataDataPointsProps)),
  addPoint: PropTypes.func,
  itemClickHandler: PropTypes.func,
  setSelectedPoint: PropTypes.func,
  getClassForSelect: PropTypes.func,
  moveCard: PropTypes.func,
  deletePoint: PropTypes.func,
  setSelectedAutocomplete: PropTypes.func,
};

export default React.memo(withTranslations(InputPoint), arePropsDifferene);
